<template lang="pug">
.sc-wrap(ref="sc")
	BannerAcbApp
	.sc-adds_top
		Advertisement(
			path="/21839709139/JV_CALENADARIO_SUPERIOR",
			:size="[[640, 100], [320, 100]]",
			:viewports="[[[640, 100], [640, 100]], [[0,0], [320, 100]]]",
			id="jv_calendario_superior"
		)
	.sc-tb
		router-link.sc-tb__logo(:to="{name: $store.state.general.lang+'.home'}"): img(src="/acb-live.png", alt="ACB Live")
	Loading(v-show="loading && isFirstTime")
	.sc-subwrap
		.sc(v-show="!loading || !isFirstTime")
			header.sc-head
				h1.sc-head__title {{ $t('Calendar') }}
			.sc-opts(v-show="!loading || !isFirstTime")
				ul.sc-opts-legend-wrap(v-if="selected_round.num_matchweek || selected_week.start_date")
					li.sc-opts-legend(v-if="selected_team") {{selected_team.name}}
					li.sc-opts-legend(v-if="!isString(selected_round.num_matchweek) && selectorRoundWeek == 'round'") {{ parsedDescriptor(selected_round.descriptor) }}
					li.sc-opts-legend(v-else-if="selected_round.num_matchweek && selectorRoundWeek == 'round'") {{ parsedDescriptor(selected_round.descriptor) }}
					li.sc-opts-legend(v-if="!isString(selected_week.start_date) && selectorRoundWeek == 'week'") {{ $t('Week ') }} {{ parsedWeekStart(selected_week.start_date) }}
					li.sc-opts-legend(v-else-if="selected_week.start_date && selectorRoundWeek == 'week'") {{ selected_week.start_date }}
					li.sc-opts-legend(v-if="selected_competition.competition.official_name") {{selected_competition.competition.official_name}}
					li.sc-opts-legend(v-if="selected_year") {{selected_year}}-{{selected_year+1}}

				.sc-opts-filt_button(role="button" @click="toggleFilters()")
					span {{ $t('Other matches') }}
					i: font-awesome-icon(icon="sort")

				transition(name='fade')
					form.sc-opts-filter-wrap(v-show="showFilters")
						.sc-opts-filter-prin
							.sc-opts-filter.sc-opts-filter--season
								span.sc-opts-filter__label {{ $t('Season') }}
								.sc-opts-filter-cnt
									select.sc-opts-filter-real(
										@change="selectYear(selected_year)"
										v-model="selected_year"
									)
										option(
											v-for="year of year_list"
											v-if="year>=oldestACBLeagueYear"
											:value="year"
										) {{year}}-{{year+1}}

									.sc-opts-filter__fake(v-if="selected_round.num_matchweek || selected_week.start_date") 
										span {{selected_year}}-{{selected_year+1}}
										i: font-awesome-icon(icon="chevron-down")


							.sc-opts-filter.sc-opts-filter--competition
								span.sc-opts-filter__label {{ $t('Competition') }}
								.sc-opts-filter-cnt
									select.sc-opts-filter-real(
										@change="selectCompetition(selected_competition)"
										v-model="selected_competition"
									)
										option(
											v-for="competition of competition_list"
											:value="competition"
										) {{competition.competition.official_name}}

									.sc-opts-filter__fake(v-if="selected_round.num_matchweek || selected_week.start_date") 
										span {{selected_competition.competition.official_name}}
										i: font-awesome-icon(icon="chevron-down")

							.sc-opts-filter.sc-opts-filter--club
								span.sc-opts-filter__label {{ $t('Team') }}
								.sc-opts-filter-cnt
									select.sc-opts-filter-real(
										v-model="selected_team"
									)
										option(v-show="(selectorRoundWeek == 'week' && selected_week) || (selectorRoundWeek == 'round' && selected_round)" :value="null" selected) {{ $t('All teams') }}
										option(
											v-for="team of team_list"
											:value="team"
										) {{team.name}}
									.sc-opts-filter__fake(v-if="selected_team && (selected_round.num_matchweek || selected_week.start_date)") 
										span {{selected_team.name}}
										i: font-awesome-icon(icon="chevron-down")

									.sc-opts-filter__fake(v-else-if="selected_round.num_matchweek || selected_week.start_date") 
										span {{ $t('All teams') }}  
										i: font-awesome-icon(icon="chevron-down")

							.sc-opts-filter.sc-opts-filter--round
								.sc-opts-filter-toggle(:filter="selectorRoundWeek")
									.sc-opts-filter-toggle__round(
										role="button"
										@click="selectRounds()"
									) 
										| {{ $t('Round') }}

									.sc-opts-filter-toggle__switch(
										role="button"
										@click="toggleRoundWeek()"
									)
										.sc-opts-filter-toggle__switch__sel
									.sc-opts-filter-toggle__week(
										role="button"
										@click="selectWeeks()"
									)
										|{{ $t('Week') }}

								.sc-opts-filter-cnt(v-if="selectorRoundWeek == 'round'")
									select.sc-opts-filter-real(
										v-model="selected_round"
									)
										option(v-if="selectorRoundWeek == 'round' && selected_team" :value="{num_matchweek: this.$i18n.t('All matches'), id: null, descriptor: this.$i18n.t('All matches')}") {{ $t('All matches') }}
										option(
											v-for="round of round_list"
											:value="{num_matchweek: round.num_matchweek, id: round.id, descriptor: round.descriptor}"
										) {{ parsedDescriptor(round.descriptor) }}

									.sc-opts-filter__fake(v-if="!isString(selected_round.num_matchweek)") 
										span {{ parsedDescriptor(selected_round.descriptor) }}
										i: font-awesome-icon(icon="chevron-down")

									.sc-opts-filter__fake(v-else-if="selected_round.num_matchweek") 
										span {{ parsedDescriptor(selected_round.descriptor) }}
										i: font-awesome-icon(icon="chevron-down")
								.sc-opts-filter-cnt(v-if="selectorRoundWeek == 'week'")
									select.sc-opts-filter-real(
										v-model="selected_week"
									)
										option(v-if="selectorRoundWeek == 'week' && selected_team" :value="{start_date: this.$i18n.t('All matches'), id: null}") {{ $t('All matches') }}
										option(
											v-for="week of week_list"
											:value="{start_date: week.start_date, id: week.id}"
										) {{ $t('Week') }} {{ parsedWeekStart(week.start_date) }}

									.sc-opts-filter__fake(v-if="!isString(selected_week.start_date)") 
										span {{ $t('Week') }} {{ parsedWeekStart(selected_week.start_date) }}
										i: font-awesome-icon(icon="chevron-down")

									.sc-opts-filter__fake(v-else-if="isString(selected_week.start_date)") 
										span {{ selected_week.start_date }}
										i: font-awesome-icon(icon="chevron-down")


						.sc-opts__reset(
							@click="getActual()"
							role="button"
							)
							i: font-awesome-icon(icon="undo")
							span {{ $t('Reset values') }}


			.sc-group(v-show="initialFail")
				Loading
			transition(name="fade")
				.sc-group(v-show="!loading")
					.sc-group-head
						.sc-group-head-lft
							span.sc-group-head__title(v-if="isString(selected_round.num_matchweek) && selectorRoundWeek == 'round'") {{ parsedDescriptor(selected_round.descriptor) }}
							span.sc-group-head__title(v-else-if="selected_round.num_matchweek && selectorRoundWeek == 'round'") {{ parsedDescriptor(selected_round.descriptor) }}
							span.sc-group-head__title(v-if="!isString(selected_week.start_date) && selectorRoundWeek == 'week'") {{ $t('Week') }} {{ parsedWeekStart(selected_week.start_date) }}
							span.sc-group-head__title(v-else-if="selected_week.start_date && selectorRoundWeek == 'week'") {{ selected_week.start_date }}

							.sc-group-head-act(v-if="(selectorRoundWeek == 'round' && selected_round.id) || (selectorRoundWeek == 'week' && selected_week.id)")
								.sc-group-head-act__prev(
									role="button"
									@click="moveRoundWeek('prev')"
									v-show="canMovePrev"
									)
									i: font-awesome-icon(icon="chevron-left")
								.sc-group-head-act__next(
									role="button"
									@click="moveRoundWeek('next')"
									v-show="canMoveNext"
									)
									i: font-awesome-icon(icon="chevron-right")

						.sc-group-head-live(
							:visible="showLiveBtn ? true : false"
							@click="scrollToCurrentMatch()"
						): .ge-btn.ge-btn--gradient(
							role="button"
						)
							.ge-match-time-info__live
							| En directo

					.sc-day(v-for="day of getDayList()")
						span.sc-day__title {{day.verbose}}
						.sc-match-list
							.sc-match-wrap(
								v-for="match in filteredMatchList" 
								v-if="isToday((match.date+match.time),day.datetime)"
								:key="match.id"
								:id="match.live ? 'live-'+match.id : match.id"
							)
								.sc-match
									
									router-link.sc-match-score.ge-match.ge-match--nav(:to="{name: getRouterViewName(match), params: {id_match: match.id}}")
										.ge-match-time
											.ge-match-time-info(v-if="match.finalized")
												span {{ $t('Finished') }}
											.ge-match-time-info(v-else-if="match.live && match.period == 3 && match.crono == 600")
												.ge-match-time-info__live
												span {{ $t('Half-time') }}
											.ge-match-time-info(v-else-if="match.live")
												.ge-match-time-info__live
												span(v-if="(match.period > 4)") {{ $t('OT') }} {{match.period - 4}}
												span(v-else) {{match.period}}{{ $t('Q') }}
											.ge-match-time-info(v-else-if="isRoasterReady(match)")
												span {{ parsedTime(match.time,match.date) }}

										.ge-match-info-wrap(:id="match.live ? 'live-score-'+match.id : 'score-'+match.id")
											.ge-match-info
												.ge-match-info__name 
													span {{ match.local_team.team_abbrev_name }}
												.ge-match-info-shield
													img(:src="match.local_image", :alt="match.local_team.team_abbrev_name")
												.ge-match-info__score(v-if="match.live || match.finalized || isRoasterReady(match)")
													AnimatedValue(:value="isRoasterReady(match) ? '-' : match.score_local")
											.ge-match-info__hour(v-if="!(match.live || match.finalized || isRoasterReady(match))")
												span {{ parsedTime(match.time,match.date) }}
											.ge-match-info
												.ge-match-info__score(v-if="match.live || match.finalized || isRoasterReady(match)")
													AnimatedValue(:value="isRoasterReady(match) ? '-' : match.score_visitor")
												.ge-match-info-shield
													img(:src="match.visitor_image", :alt="match.visitor_team.team_abbrev_name")
												.ge-match-info__name 
													span {{ match.visitor_team.team_abbrev_name }}
										span.ge-match__round(v-if="selectorRoundWeek == 'week' || !selected_round.id") {{ $t('Round') }} {{ match.matchweek_number }}
									.sc-match__location(v-if="match.arena")
										i: font-awesome-icon(icon="map-marker-alt")
										span
											| {{match.arena.name}}

									//-Si acbtv
									//- a(href="player..com").sc-match__acbtv
									//- 	| {{ $t('Watch match') }}
									//- 	i: font-awesome-icon(icon="play-circle")

									//-Si desde el live
									a(v-if="match.Broadcasts.length" :href="match.Broadcasts[0].url").sc-match__tv
										img(:src="match.Broadcasts[0].url_image")

									router-link.sc-match__live(:to="{name: getRouterViewName(match), params: {id_match: match.id}}")
										| {{ $t('See stats') }}
										i: font-awesome-icon(icon="arrow-right")

		.sc-adds_primary(v-show="(!isFirstTime && !isSmall) || (!loading && isSmall)")
			Advertisement(
				path="/21839709139/JV_CALENADARIO_LATERAL",
				:size="[300, 600]",
				:viewports="[]",
				id="jv_calendario_lateral"
			)

	footer.sc-ft
		form.sc-ft-lang
			//- select(onChange="language.update(this.value, '{% url \'set-language\' %}')")
			select(v-model="lang")
				option(value="es") {{ $t('Spanish') }}
				option(value="en") {{ $t('English') }}

		ul.sc-ft-legal
			li.sc-ft-legal__link: a(href="http://www.acb.com/Documentos/aviso_legal_acbcom.pdf" target="_blank" rel="noopener") {{ $t('Legal notice') }}
			li.sc-ft-legal__link: a(href="http://www.acb.com/index/politica" target="_blank" rel="noopener") {{ $t('Data protection policy') }}
			li.sc-ft-legal__link: a(href="http://www.acb.com/aviso-cookies/politica" target="_blank" rel="noopener") {{ $t('Cookies policy') }}

		.sc-ft-logo
			router-link(:to="{name: $store.state.general.lang+'.home'}"): img(src="/acb-live.png", alt="ACB Live")
			span Copyright &#169 ACB.COM, 2001-2020

</template>

<style lang="sass">

$s-breakpoint: 800px
.sc
	display: grid
	box-sizing: border-box
	grid-auto-flow: row
	align-content: start
	+breakpoint(large)
		grid-column-gap: 6rem

	&-subwrap
		display: grid
		max-width: $global-width-wrap
		justify-content: space-between
		min-height: 80vh
		margin: 0 auto
		padding: 2rem 1rem
			bottom: 12rem
		grid-template-columns: 1fr
		grid-column-gap: 3rem
		grid-row-gap: 6rem
		box-sizing: border-box
		+breakpoint($s-breakpoint)
			grid-template-columns: minmax(auto, 800px) 300px
	&-head
		padding-bottom: 0.5rem
		&__title
			+h2

	&-opts
		display: grid
		grid-auto-flow: row
		align-content: start
		width: 100%
		&-legend
			font-weight: $bold
			font-size: 1.2rem
			padding-right: 0.5em
			box-sizing: border-box
			&:not(:last-child)
				&::after
					content: ","
			&-wrap
				margin: 0
				padding: 0
				list-style: none
				display: flex
				flex-wrap: wrap
				padding-bottom: 2rem
				
		&-filter
			background-color: $white
			box-sizing: border-box
			position: relative
			display: flex
			flex-direction: row
			border-right: 1px solid $light-grey
			height: 100%
			+breakpoint(medium)
				flex-direction: column

			
			&--season, &--competition, &--round, &--club
				border-bottom: 1px solid $light-grey
				+breakpoint(medium)
					border-bottom: none
			&--season
				grid-area: season

			&--competition
				grid-area: competition

			&--round
				grid-area: round
			
			&--club
				grid-area: club

			&-wrap
				display: grid
				grid-template-columns: 1fr
				+breakpoint(medium)
					grid-template-columns: 1fr auto

			&-prin
				display: grid
				box-shadow: 0 0 4px 0px rgba($black, 0.3)
				grid-template-columns: 1fr
				grid-template-areas: "season" "competition" "club" "round"
				+breakpoint(medium)
					grid-template-columns: 1fr 1fr
					grid-template-areas: "season competition" "club round"
				+breakpoint(large)
					grid-template-columns: 1fr 1fr 1fr 1fr 
					grid-template-areas: "season competition club round"

			&-cnt
				position: relative
				display: flex
				align-items: center
				background-color: #EEEEEE
				min-height: 40px
				width: 100%
				max-width: (2/3) * 100%
				padding: 0.8rem
				+breakpoint(medium)
					min-height: initial
					max-width: initial
					width: initial
					max-height: 50%
					height: 100%
				

			&__label, &-toggle
				display: grid
				grid-auto-flow: column
				justify-content: start
				align-items: center
				min-height: 40px
				width: 100%
				max-width: (1/3) * 100%
				padding: 0.8rem
				grid-gap: 0.5rem
				font-weight: $bold
				+breakpoint(medium)
					min-height: initial
					max-width: initial
					width: initial
					max-height: 50%
					height: 100%
			&-toggle
				position: relative
				display: grid
				align-items: center
				grid-template-columns: auto 1fr
				grid-gap: 0.5rem
				grid-template-areas: "toggle filround" "toggle filweek"
				+breakpoint(medium)
					grid-gap: 1rem
					grid-template-columns: repeat(3, auto)
					grid-template-areas: "filround toggle filweek"
				+breakpoint(large)
					justify-content: space-between
					

				&[filter="round"]
					.sc-opts-filter-toggle
						&__round
							color: $black
						&__week
							color: $grey
					.sc-opts-filter-toggle__switch__sel:before
						transform: translateY(-30px)
						@media(hover: hover)
							transform: translateY(0)

				&[filter="week"]
					.sc-opts-filter-toggle
						&__round
							color: $grey
						&__week
							color: $black
					.sc-opts-filter-toggle__switch__sel:before
						@media (min-width: $medium), (hover: hover)
							transform: translateX(20px)
	
				&__round
					grid-area: filround
					cursor: pointer
				&__week
					grid-area: filweek
					cursor: pointer

				&__switch
					position: relative
					display: inline-block

					width: 30px
					height: 60px
					grid-area: toggle
					@media (min-width: $medium), (hover: hover)
						width: 40px
						height: 20px

					&__sel
						position: absolute
						cursor: pointer
						top: 0
						left: 0
						right: 0
						bottom: 0
						background-image: $gradient-selected
						-webkit-transition: .4s
						transition: .4s
						border-radius: 34px

						&:before
							position: absolute
							content: ""
							height: 26px
							width: 26px
							left: 2px
							bottom: 2px
							background-color: $white
							-webkit-transition: .4s
							transition: .4s
							border-radius: 50%
							@media (min-width: $medium), (hover: hover)
								height: 16px
								width: 16px
			&-real
				background-color: $white
				position: absolute
				left: 0
				top: 0
				height: 100%
				width: 100%
				opacity: 0
				@media (hover: hover) and (pointer: fine)
					&:hover
						cursor: pointer
				option
					background-color: $white
					color: $black
					border: 0
					outline: 0

			&__fake
				display: flex
				width: 100%
				justify-content: space-between
				& > i
					color: $primary-color

		&__reset
			border: none
			display: grid
			grid-auto-flow: column
			justify-self: center
			align-self: center
			grid-gap: 1rem
			line-height: 1.2em
			font-weight: $bold
			padding: 2rem
			color: $grey
			font-size: 1.2rem
			& > span
				+breakpoint(medium)
					display: none
			@media (hover: hover) and (pointer: fine)
				&:hover
					cursor: pointer
					color: $primary-color

		&-filt_button
			background-color: $white
			display: flex
			justify-content: space-between
			align-items: center
			height: 50px
			padding: 0 1rem
			box-shadow: 0 0 4px 0px rgba($black, 0.3)
			border-bottom: 3px solid $primary-color
			font-size:  1.2rem
			font-weight: $bold
			color: $primary-color
			+breakpoint(medium)
				display: none

			& > i
				font-size: 1.3rem

	&-group
		width: 100%
		display: grid
		grid-auto-flow: row
		grid-gap: 1rem
		padding: 4rem 0
		&:last-child
			padding-bottom: 0

		&-head
			display: flex
			grid-gap: 2rem
			justify-content: space-between
			align-items: center

			&-lft
				display: grid
				grid-auto-flow: column
				width: 100%
				justify-content: space-between
				+breakpoint(medium)
					max-width: 240px

			&__title
				+h3
			&-act
				display: grid
				grid-auto-flow: column
				grid-gap: 3.5rem
				padding-right: 1rem
				+breakpoint(medium)
					grid-gap: 1.5rem
					padding-right: 0

				&__prev, &__next
					color: $primary-color
					font-size: 1.4em
					cursor: pointer
			&-live
				visibility: hidden
				opacity: 0
				transform: translateX(100%)
				right: 0
				bottom: 0
				margin-bottom: 4rem
				position: fixed
				transition: transform 0.2s, opacity 0.4s
				box-shadow: 0 0 6px 0px rgba($black,0.4)
				+breakpoint(medium)
					transform: translateX(0)
					position: initial
					opacity: 0
					visibility: hidden
					margin-bottom: 0
					box-shadow: initial


				&[visible]
					opacity: 1
					transform: translateX(0)
					visibility: visible
					transition: transform 0.2s, opacity 0.4s

				& > *
					align-items: center

				.ge-match-time-info__live
					background-color: $white


	&-day
		display: grid
		grid-auto-flow: row
		grid-gap: 1rem
		padding-bottom: 6rem
		&__title
			font-size: 1.2rem
			font-weight: $bold
		&-adds
			display: flex
			justify-content: center
			& > img
				max-height: 50px
				max-width: 150px
				object-fit: contain
				width: 100%
			&-wrap
				display: grid
				grid-template-columns: 1fr 1fr
				grid-column-gap: 1rem
				grid-row-gap: 3rem
				justify-content: space-around
				padding-bottom: 4rem

				+breakpoint(medium)
					grid-template-columns: initial
					grid-auto-flow: column


			
	&-match
		display: grid
		justify-content: center
		padding: 2rem 0
		align-items: center
		max-width: 1000px
		width: 100%
		grid-column-gap: 2rem
		grid-row-gap: 1.5rem
		grid-template-columns: 1fr
		grid-template-areas: "score" "location" "tv" "live"
		justify-items: center
		+breakpoint(500px)
			grid-template-columns: 300px auto
			grid-template-areas: "score tv" "location live"

		+breakpoint(1100px)
			justify-content: space-between
			grid-template-columns: 300px 1fr minmax(auto, 100px) auto
			grid-gap: 3rem
			grid-template-areas: "score location tv live"
			justify-items: start

		&-wrap
			// display: flex
			justify-content: center
			border-bottom: 1px solid $light-grey
			&:first-child
				border-top: 1px solid $light-grey

		&-score
			grid-area: score
			color: $black
			@media (hover: hover) and (pointer: fine)
				&:hover
					color: $black
		
		&__location
			grid-area: location
			display: grid
			grid-auto-flow: column
			grid-gap: 0.5rem
			justify-content: start
			align-items: center
			line-height: 1.2em

			+breakpoint(500px)
				padding: 0

			& > i
				color: $black
		&__acbtv, &__live
			display: grid
			grid-auto-flow: column
			grid-gap: 0.5rem
			align-items: center
			text-decoration: none
			text-transform: uppercase
			line-height: 1.2em
			justify-content: start
			min-height: 30px
			text-align: center
			font-size: 1.1rem
			+breakpoint(medium)
				padding-top: 0
			& > i
				font-size: 1.2rem

		&__acbtv, &__tv
			grid-area: tv


		&__live
			grid-area: live
			& > i
				color: $primary-color
			@media (hover: hover) and (pointer: fine)
				&:hover
					color: $primary-color

		&__tv
			& > img
				width: 100%
				max-height: 30px
				max-width: 80px
				object-fit: contain
			
		&__acbtv
			@media (hover: hover) and (pointer: fine)
				&:hover
					color: lighten($primary-color,10%)

	&-tb
		width: 100%
		background-color: $black
		display: flex
		justify-content: center
		padding: 1rem
		box-sizing: border-box
		align-items: center
		box-shadow: 0 0 3px 0px $black

		&__logo
			& > img
				max-height: 35px

	&-ft
		width: 100%
		padding: 2rem 1rem
		box-sizing: border-box
		background-color: $black
		display: grid
		grid-auto-flow: row
		justify-items: center
		grid-row-gap: 3rem
		+breakpoint(medium)
			grid-row-gap: 1.5rem

		&-lang
			padding-bottom: 1em
			& > select
				width: 100px
				background-color: transparent
				padding: 0.5rem
				box-sizing: border-box
				color: $white
				border: 1px solid $white
				background-image: none
				& > option
					color: $black
		&-legal
			width: 100%
			max-width: 400px
			justify-content: space-between
			display: flex
			grid-gap: 1rem
			padding: 0
			margin: 0
			list-style: none
			flex-direction: column
			+breakpoint(medium)
				flex-direction: row
			&__link
				text-align: center
				line-height: 1.2em
				& > a
					color: $white
					text-transform: uppercase
					font-size: 0.9em
					text-decoration: none
		&-logo
			display: grid
			grid-auto-flow: row
			justify-items: center
			grid-gap: 0.5rem
			img
				max-height: 30px
			& > span 
				color: $white


	&-adds_primary
		display: flex
		justify-self: center
				
	&-adds_top
		position: relative
		display: flex
		background-color: $dark-grey
		z-index: 2
		bottom: 0
		justify-content: center
		width: 100%

		&__close
			position: absolute
			right: 0
			top: 0
			transform: translateY(-100%)
			color: $white
			background-color: $dark-grey
			font-size: 1.2rem
			cursor: pointer
			width: 30px
			height: 30px
			display: flex
			justify-content: center
			align-items: center
			+breakpoint(medium)
				display: none
	

		


				

</style>

<script>

import api from "@/api/index"

import Loading from "@/components/subcomponents/general/Loading.vue"
import Advertisement from "@/components/subcomponents/general/Advertisement.vue";
import AnimatedValue from "@/components/subcomponents/general/AnimatedValue.vue"
import BannerAcbApp from "@/components/subcomponents/BannerAcbApp.vue"


export default {
	name: "Home",
	metaInfo() {
		return {
			title: `${this.$i18n.t('Calendar')} | ACB Live`,
			meta: [
				{
					name: 'description',
					content: this.$i18n.t('meta_description')
				}
			]
		}
	},
	data() {
		return {
			showFilter: false,
			lang: this.$store.state.general.lang,
			loading: true,
			isFirstTime: true,
			canUpdateMatch: false,
			match_list: [],
			team_list: [],
			round_list: [],
			week_list: [],
			competition_list: [],
			year_list: [],
			selected: {
				year: null,
				competition: null,
				round: null,
				team: null,
			},
			selected_year: '',
			selected_competition: { competition: { name: '' } },
			selected_round: { num_matchweek: this.$i18n.t('All matches'), id: null, descriptor: this.$i18n.t('All matches') },
			selected_week: { start_date: this.$i18n.t('All matches'), id: null },
			selected_team: null,
			actual: {
				year: false,
				competition: false,
				edition: false,
				round: false,
				week: false,
				phase: false
			},
			currCompRound: null,
			busy_toggling: false,
			initialFail: false,
			initialTimer: null,
			showLiveBtn: false,
		}
	},
	computed: {
		oldestACBLeagueYear() {
			return this.$store.state.general.oldestACBLeagueYear
		},
		selectorRoundWeek() {
			return this.$store.state.general.selectorRoundWeek
		},
		refreshSignal() {
			return this.$store.state.general.refreshSignal
		},
		filteredMatchList() {
			if (this.$data.selected_team && !this.$data.selected_round.id) {
				return this.filterByTeam()
			} else if (this.$data.selected_team && this.$data.selected_round.id) {
				return this.filterByRound()
			} else {
				return this.$data.match_list
			}
		},
		showFilters() {
			if (this.isSmall) {
				return this.showFilter
			} else {
				return true
			}
		},
		isSmall() {
			return this.$store.state.general.isSmall
		},
		canMoveNext() {
			if (this.selectorRoundWeek == 'round') {
				let obj = this.round_list.find(x => x.id === this.selected_round.id)
				let index = this.round_list.indexOf(obj)
				return !!this.round_list[index - 1]
			} else {
				let obj = this.week_list.find(x => x.id === this.selected_week.id)
				let index = this.week_list.indexOf(obj)
				return !!this.week_list[index - 1]
			}
		},
		canMovePrev() {
			if (this.selectorRoundWeek == 'round') {
				let obj = this.round_list.find(x => x.id === this.selected_round.id)
				let index = this.round_list.indexOf(obj)
				return !!this.round_list[index + 1]
			} else {
				let obj = this.week_list.find(x => x.id === this.selected_week.id)
				let index = this.week_list.indexOf(obj)
				return !!this.week_list[index + 1]
			}
		},
	},
	methods: {
		getRouterViewName(match) {
			return (match.live || match.finalized || match.selected_players) ? this.$store.state.general.lang+'.overview' : this.$store.state.general.lang+'.prematch'
		},
		isRoasterReady(match) {
			return match.selected_players
		},
		parsedDescriptor(descriptor) {
			// translate descriptor (can't be translated using regular module)
			if (this.$store.state.general.lang == 'en') {
				if (descriptor.includes('Jornada')) {
					return descriptor.replace('Jornada', 'Round') // Matchweek instead of round?
				}
				else if (descriptor.includes('1/8 de final')) {
					return descriptor.replace('1/8 de final', 'Last 16')
				}
				else if (descriptor.includes('1/4 de final')) {
					return descriptor.replace('1/4 de final', 'Quarterfinals')
				}
				else if (descriptor.includes('Semifinales')) {
					return descriptor.replace('Semifinales', 'Semifinals')
				}
				else {
					return descriptor
				}
			}
			return descriptor
		},
		scrollToCurrentMatch() {
			let selectedItem = document.querySelector('[id^="live-"]')
			if (selectedItem) {
				let allMatches = document.getElementsByClassName('sc-match-wrap')
				let index = [].indexOf.call(allMatches, selectedItem)
				let position = selectedItem.offsetTop - 100
				if (index) {
					selectedItem = allMatches[index - 1]
					position = selectedItem.offsetTop + selectedItem.clientHeight / 2
				}
				this.$nextTick(() => {
					window.scroll(0, position)
				})
			}
		},
		moveRoundWeek(direction) {
			if (this.selectorRoundWeek == 'round') {
				let obj = this.round_list.find(x => x.id === this.selected_round.id)
				let index = this.round_list.indexOf(obj)
				if (index >= 0) {
					if (direction == 'prev') {
						let prev_round = this.round_list[index + 1]
						if (prev_round) {
							this.selected_round = { num_matchweek: prev_round.num_matchweek, id: prev_round.id, descriptor: prev_round.descriptor }
						}
					} else if (direction == 'next') {
						let next_round = this.round_list[index - 1]
						if (next_round) {
							this.selected_round = { num_matchweek: next_round.num_matchweek, id: next_round.id, descriptor: next_round.descriptor }
						}
					}
				}
			} else if (this.selectorRoundWeek == 'week') {
				let obj = this.week_list.find(x => x.id === this.selected_week.id)
				let index = this.week_list.indexOf(obj)
				if (index >= 0) {
					if (direction == 'prev') {
						let prev_week = this.week_list[index + 1]
						if (prev_week) {
							this.selected_week = { start_date: prev_week.start_date, id: prev_week.id }
						}
					} else if (direction == 'next') {
						let next_week = this.week_list[index - 1]
						if (next_week) {
							this.selected_week = { start_date: next_week.start_date, id: next_week.id }
						}
					}
				}
			}
		},
		parsedWeekStart(date) {
			let datetime = new Date(date * 1000)
			return `${datetime.getDate()}/${datetime.getMonth() + 1}`
		},
		toggleRoundWeek() {
			this.$data.loading = true
			this.$data.busy_toggling = true
			if (this.selectorRoundWeek == 'round') {
				this.selectWeeks()
			} else {
				this.selectRounds()
			}
		},
		selectRounds() {
			if (this.selectorRoundWeek == 'week') {
				this.$store.commit('general/setSelectorRoundWeek', 'round')
				this.getActual()
			}
		},
		selectWeeks() {
			if (this.selectorRoundWeek == 'round') {
				this.$store.commit('general/setSelectorRoundWeek', 'week')
				this.getActual()
			}
		},
		hideBanner() {
			this.$store.commit("general/setShowHomeBanner", false);
		},
		toggleFilters() {
			this.showFilter = !this.showFilter
		},
		isString(value) {
			return (typeof value === 'string' || value instanceof String)
		},
		isToday(match_date, day_date) {
			if (!match_date && !day_date) {
				return true
			}
			if (day_date) {
				if (new Date(match_date * 1000).getDate() == day_date.getDate() && new Date(match_date * 1000).getMonth() == day_date.getMonth()) {
					return true
				}
			}
			return false
		},
		getDayList() {
			let days = []
			let day_list = []
			for (let match of this.filteredMatchList) {
				if (match.date && match.time) {
					let match_date = new Date((match.date + match.time) * 1000)
					let day = `${match_date.getDate()}-${match_date.getMonth()}`
					if (days.indexOf(day) < 0) {
						day_list.push(
							{
								datetime: match_date,
								verbose: `${this.getDay(match_date.getDay())} ${match_date.getDate()} ${this.$i18n.t('of')} ${this.getMonth(match_date.getMonth())}`
							}
						)
					}
					days.push(day)
				} else if (match.date) {
					let match_date = new Date((match.date) * 1000)
					let day = `${match_date.getDate()}-${match_date.getMonth()}`
					if (days.indexOf(day) < 0) {
						day_list.push(
						{
							datetime: match_date,
							verbose: `${this.getDay(match_date.getDay())} ${match_date.getDate()} ${this.$i18n.t('of')} ${this.getMonth(match_date.getMonth())}`
						}
						)
					}
					days.push(day)
				} else {
					let match_date = this.$i18n.t('Date to be determined')
					if (days.indexOf(match_date) < 0) {
						day_list.push(
							{
								datetime: match.date,
								verbose: match_date
							}
						)
					}
					days.push(match_date)
				}
			}
			return day_list
		},
		getDay(day) {
			return this.$i18n.t(['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][day])
		},
		getMonth(month) {
			return this.$i18n.t(['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'][month])
		},
		parsedTime(time, date) {
			if (!time) {
				return this.$i18n.t('TBD')
			}
			let d = new Date((date + time) * 1000);
			return d.toTimeString().substr(0, 5);
			// return d.toUTCString().slice(17,22);
		},
		getActual() {
			api.competition.getActual()
				.then((data) => {
					this.$data.actual = data.actual
					this.updateYearList()
					this.selectYear(this.$data.actual.year)
					this.selected_team = null
				})
		},
		updateTeamList() {
			if (this.match_list.length) {
				let team_list = []
				let teams = []
				for (let match of this.$data.match_list) {
					if (!team_list.includes(match['local_team']['team_actual_short_name'])) {
						team_list.push(match['local_team']['team_actual_short_name'])
						teams.push(
							{ name: match['local_team']['team_actual_short_name'], id: match['id_team_local'] }
						)
					}
					if (!team_list.includes(match['visitor_team']['team_actual_short_name'])) {
						team_list.push(match['visitor_team']['team_actual_short_name'])
						teams.push(
							{ name: match['visitor_team']['team_actual_short_name'], id: match['id_team_visitor'] }
						)
					}
				}
				this.$data.team_list = teams
			}
		},
		updateMatchList(ed, c, r) {
			if (r && this.canUpdateMatch) {
				this.setInitialTimer()
				this.$data.team_list = []
				api.competition.getMatchList(ed, c, r)
					.then((data) => {
						this.$data.match_list = data
						this.updateTeamList()
						this.$data.loading = false
						this.$data.isFirstTime = false
						if (data) {
							this.clearInitialTimer()
						}
					}
					)
			}
			this.$data.canUpdateMatch = false
		},
		updateMatchListByWeek(ed, c, w) {
			if (w && this.canUpdateMatch) {
				this.setInitialTimer()
				this.$data.team_list = []
				api.competition.getMatchListByWeek(ed, c, w)
					.then((data) => {
						this.$data.match_list = data
						this.updateTeamList()
						this.$data.loading = false
						this.$data.isFirstTime = false
						if (data) {
							this.clearInitialTimer()
						}
					}
					)
			}
			this.$data.canUpdateMatch = false
		},
		getAllMatches(ed, c) {
			if (this.canUpdateMatch && !this.$data.busy_toggling) {
				this.$data.team_list = []
				this.$data.loading = true
				api.competition.getAllMatches(ed, c)
					.then((data) => {
						this.$data.match_list = data
						this.updateTeamList()
						this.$data.loading = false
						this.$data.isFirstTime = false
					}
					)
			}
			this.$data.canUpdateMatch = false
		},
		updateRoundList(ed, c) {
			this.$data.team_list = []
			api.competition.getRoundList(ed, c)
				.then((data) => {
					this.$data.round_list = data
					this.updateCurrCompRound(data)
				}
				)
		},
		updateWeekList(ed, c) {
			this.$data.team_list = []
			api.competition.getWeekList(ed, c)
				.then((data) => {
					let aux_week_list = []
					if (data.length) {
						for (let week of data) {
							aux_week_list.push({ start_date: week.start_date, id: week.id })
						}
						this.$data.week_list = aux_week_list
						this.updateCurrCompWeek(aux_week_list)
					} else {
						this.toggleRoundWeek()
					}
				})
		},
		updateCurrCompRound(round_list) {
			api.competition.getCurrentRound(this.$data.actual.edition.id, this.$data.actual.competition.id)
				.then((data) => {
					if (data) {
						this.selected_team = null
						this.selected_round = { num_matchweek: data.num_matchweek, id: data.id, descriptor: data.descriptor }
					} else {
						var lastRound = round_list.slice(-1).pop();
						this.selected_round = { num_matchweek: lastRound.num_matchweek, id: lastRound.id, descriptor: lastRound.descriptor }
					}
				})
		},
		updateCurrCompWeek(week_list) {
			api.competition.getCurrentWeek(this.$data.actual.edition.id, this.$data.actual.competition.id)
				.then((data) => {
					if (data) {
						this.selected_team = null
						if (!this.week_list.some(week => week.id === data.id)) {
							this.selected_week = week_list[week_list.length - 1]
						} else {
							this.selected_week = { start_date: data.start_date, id: data.id }
						}
					} else {
						var lastWeek = week_list.slice(-1).pop();
						this.selected_week = { start_date: lastWeek.start_date, id: lastWeek.id }
					}
				})
		},
		getSelectedCompetition(list) {
			for (let competition of list) {
				if (competition.id_competition == this.$data.actual.competition.id) {
					return competition
				}
			}
			return list[0]
		},
		updateCompetitionList(y) {
			this.$data.team_list = []
			this.$data.round_list = []
			api.competition.getCompetitionList(y)
				.then((data) => {
					if (data)
						this.$data.competition_list = data
					else
						this.$data.competition_list = [this.$i18n.t('No competitions')]
					this.selectCompetition(this.getSelectedCompetition(this.$data.competition_list))
				}
				)
		},
		updateYearList() {
			this.$data.team_list = []
			this.$data.competition_list = []
			api.competition.getYearList()
				.then((data) => {
					this.$data.year_list = data
				}
				)
		},
		selectYear(year) {
			this.$data.selected_year = year
			this.updateCompetitionList(year)
		},
		selectCompetition(competition) {
			if (this.$data.actual.competition.id == this.$data.selected_competition.id_competition || this.$data.selected_competition.id == null) {
				this.$data.selected_competition = competition
			}
			this.$data.actual.competition.id = this.$data.selected_competition.id_competition
			this.$data.actual.edition.id = this.$data.selected_competition.id
			if (this.selectorRoundWeek == 'round')
				this.updateRoundList(this.$data.actual.edition.id, this.$data.actual.competition.id)
			if (this.selectorRoundWeek == 'week')
				this.updateWeekList(this.$data.actual.edition.id, this.$data.actual.competition.id)
		},
		selectRound(round) {
			this.canUpdateMatch = true
			this.$data.loading = true
			if (!round) {
				round = { num_matchweek: this.$i18n.t('All matches'), id: null, descriptor: this.$i18n.t('All matches') }
				this.getAllMatches(this.$data.actual.edition.id, this.$data.actual.competition.id)
			}
			this.$data.actual.round.id = round.id
			this.$data.actual.round.matchweek_number = round.num_matchweek
			this.$data.actual.round.descriptor = round.descriptor
			this.updateMatchList(this.actual.edition.id, this.actual.competition.id, this.actual.round.id)
			this.$data.busy_toggling = false
		},
		selectWeek(week) {
			if (week) {
				this.canUpdateMatch = true
				this.$data.loading = true
				if (!week.id) {
					week = { start_date: this.$i18n.t('All matches'), id: null }
					this.getAllMatches(this.$data.actual.edition.id, this.$data.actual.competition.id)
				}
				this.$data.actual.week.id = week.id
				this.$data.actual.week.start_date = week.start_date
				this.updateMatchListByWeek(this.actual.edition.id, this.actual.competition.id, this.actual.week.id)
				this.$data.busy_toggling = false
			}
		},
		selectTeam(team) {
			this.canUpdateMatch = true
			this.$data.loading = true
			if (team) {
				this.$data.match_list = []
				this.$data.loading = true
				api.competition.getMatchListByTeam(this.$data.actual.edition.id, this.$data.actual.competition.id, team.id)
					.then((data) => {
						this.$data.match_list = data
						this.$data.loading = false
						this.$data.isFirstTime = false
					}
					)
				this.$data.selected_round = { num_matchweek: this.$i18n.t('All matches'), id: null, descriptor: this.$i18n.t('All matches') }
				this.$data.selected_week = { start_date: this.$i18n.t('All matches'), id: null }
			} else {
				if (this.$data.selected_week.id) {
					this.updateMatchListByWeek(this.$data.actual.edition.id, this.$data.actual.competition.id, this.$data.selected_week.id)
				} else if (this.$data.selected_round.id) {
					this.updateMatchList(this.$data.actual.edition.id, this.$data.actual.competition.id, this.$data.selected_round.id)
				}
				else {
					if (this.selectorRoundWeek == 'week') {
						this.updateWeekList(this.$data.actual.edition.id, this.$data.actual.competition.id)
					}
					if (this.selectorRoundWeek == 'round') {
						this.updateRoundList(this.$data.actual.edition.id, this.$data.actual.competition.id)
					}
				}
			}
			this.$data.canUpdateMatch = false
			this.$data.selected_team = team
		},
		updateTeamFilter() {
			this.$data.team_list = this.getRoundTeams()
		},
		getRoundTeams() {
			let team_list = []
			for (let match of this.$data.match_list) {
				for (let team of this.getMatchTeams(match)) {
					if (team_list.indexOf(team.id) >= 0) {
						team_list.push(team)
					}
				}
			}
			return team_list
		},
		getMatchTeams(match) {
			return [match.local_team.team_actual_short_name, match.visitor_team.team_actual_short_name]
		},
		filterByTeam() {
			let filtered_list = []
			for (let match of this.$data.match_list) {
				if (match.local_team.team_actual_short_name == this.$data.selected_team.name || match.visitor_team.team_actual_short_name == this.$data.selected_team.name) {
					filtered_list.push(match)
				}
			}
			this.$data.loading = false
			return filtered_list
		},
		filterByRound() {
			let filtered_list = []
			for (let match of this.$data.match_list) {
				if (this.selectorRoundWeek == 'round') {
					if (match.matchweek_number == this.$data.selected_round.num_matchweek) {
						filtered_list.push(match)
					}
				} else if (this.selectorRoundWeek == 'week') {
					if (match.week_id == this.$data.selected_week.id) {
						filtered_list.push(match)
					}
				}
			}
			this.$data.loading = false
			return filtered_list
		},
		setInitialTimer() {
			this.initialTimer = setTimeout(
				() => {
					this.$data.initialFail = true
				},
				this.$store.state.general.requestTimeout
			)
		},
		clearInitialTimer() {
			if (this.initialTimer) {
				clearTimeout(this.initialTimer)
				this.$data.initialFail = false
			}
		},
		isLiveInViewport() {
			// Canviar per id^="[live-]"
			let selectedItem = document.querySelector('[id^="live-score-"]')
			if (selectedItem) {
				let rect = selectedItem.getBoundingClientRect()
				let inViewport = (
					rect.top >= 0 &&
					rect.left >= 0 &&
					rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
					rect.right <= (window.innerWidth || document.documentElement.clientWidth)
				)
				this.$data.showLiveBtn = !inViewport
			} else {
				this.$data.showLiveBtn = false
			}
		}
	},
	watch: {
		selected_round() {
			this.clearInitialTimer()
			if (this.selectorRoundWeek == 'round') {
				if (!this.selected_team) {
					this.selectRound(this.selected_round)
				}
			}
		},
		selected_week() {
			this.clearInitialTimer()
			if (this.selected_week) {
				if (this.selectorRoundWeek == 'week') {
					this.selectWeek(this.selected_week)
				}
			}
		},
		lang(newValue) {
			this.$store.commit('general/setLang', newValue)
			this.$router.replace(newValue)
		},
		refreshSignal(newValue) {
			if (newValue && this.$data.actual.round.id && this.$data.actual.week.id) {
				if (this.selectorRoundWeek == 'round')
					this.updateMatchList(this.actual.edition.id, this.actual.competition.id, this.actual.round.id)
				if (this.selectorRoundWeek == 'week')
					this.updateMatchListByWeek(this.actual.edition.id, this.actual.competition.id, this.actual.week.id)

			}
		},
		// filteredMatchList() {
		// 	this.$nextTick(() => this.scrollToCurrentMatch())
		// },
		selected_team() {
			this.selectTeam(this.selected_team)
		}
	},
	created() {
		this.getActual()
		this.$store.commit("general/setHeadReady", false)
		this.$store.commit("general/setError", false)
		window.addEventListener('scroll', this.isLiveInViewport())
		this.$store.commit("general/setNav", false);
	},
	mounted() {
		this.isLiveInViewport()
		this.$store.commit('general/setScreenSize', window.innerWidth)
		window.addEventListener('resize', () => {
			this.$store.commit('general/setScreenSize', window.innerWidth)
		})
		this.$refs.sc.addEventListener('touchmove', this.preventDefault, () => {
			this.isLiveInViewport(this.$refs.sc.scrollTop)
		})
		window.addEventListener('scroll', () => {
			this.isLiveInViewport()
		})

		// document.getElementsByTagName("BODY")[0].setAttribute("home","True")

	},
	// beforeDestroy(){
	// 	document.getElementsByTagName("BODY")[0].removeAttribute("home",)

	// },
	components: {
		Loading,
		Advertisement,
		AnimatedValue,
		BannerAcbApp
	},
}

</script>
